Ext.ns('mx.app.widget');

mx.app.widget.EditPanel = Ext.extend(Ext.Panel, {
    checkIsDirty: true,
    isNew: true,
    buttonAlign: 'right',
    layout: 'fit',
    rolesForHistory: ['admin', 'super_admin'],
    plugins: [
        new mx.plugin.Constraint({
            //minWidth: 710, there were some problems with mx.app.widget.OrderExpenseEditForm
            autoHeight: true,
        }),
    ],
    cls: 'mx-app-widget-editpanel',
    border: false,
    style: 'background-color: white;',
    labels: {
        warning: 'Warning',
        close: 'Close',
        save: 'Save',
        someFieldsAreWrong: 'Some fields are not filled out correctly',
        doYouWantToLeave: 'Do you want to leave row editing without saving changes?',
        history: 'History',
    },
    doYouWantToLeaveLabel: 'Do you want to leave row editing without saving changes?',
    hasCloseButton: true,
    initComponent: function() {
        mx.app.widget.EditPanel.superclass.initComponent.apply(this, arguments);

        this.addEvents('load', 'submit', 'cancel', 'invalid');

        var formclass = this.formClass;

        this.form = new this.formClass({
            style: 'padding: 10px;',
            bodyStyle: Ext.isIE ? 'padding-bottom: ' + mx.plugin.Constraint.getScrollbarWidth() + 'px;' : '',
            trackResetOnLoad: true,
            isNew: this.isNew,
            params: this.params,
            readOnly: this.readOnly,
        });

        this.on(
            'render',
            function() {
                this.el.setVisibilityMode(Ext.Element.VISIBILITY);
                this.el.setVisible(false);
            },
            this
        );

        this.on(
            'afterLayout',
            function() {
                this.fireEvent('load', this.form);
                this.el.setVisible(true);
            },
            this,
            {single: true}
        );

        this.add(this.form);

        this.form.panelButtons = this.form.panelButtons || [];
        for (var i = 0; i < this.form.panelButtons.length; i++) {
            var button = this.form.panelButtons[i];
            if (this.readOnly && button.useReadOnlyFlag) continue;
            var buttonCfg = button.buttonCfg || {};
            this.addButton(buttonCfg, button.handler, button.scope || this);
        }

        this.form.customButtons = this.form.customButtons || {};
        for (var i in this.form.customButtons) {
            if (this.form.customButtons[i] instanceof Object) {
                this.form.customButtons[i] = this.addButton(this.form.customButtons[i]);
            }
        }

        var isAudit = false;
        if (this.params && this.params.auditIds) {
            this.params.auditIds.forEach(function(i) {
                isAudit = !!i;
            });
        }
        if (this.params && this.params.auditFor && !this.isNew && isAudit && this.rolesForHistory.indexOf(ur) > -1) {
            this.addButton({
                name: 'history_btn',
                text: this.labels.history,
                onClick: function() {
                    var params = this.form.params;
                    var entityIds;
                    if (params.loadAuditIdsAfterRendering) {
                        entityIds = [];
                        var fieldNames = params.auditIds;
                        for (var j = 0; j < fieldNames.length; j++) {
                            var fid = this.form.record.get(fieldNames[j]);
                            if (!fid) {
                                alert('Field ' + fieldNames[j] + ' is undefined!');
                                entityIds[j] = 0;
                            } else {
                                entityIds[j] = fid;
                            }
                        }
                    } else {
                        entityIds = params.auditIds;
                    }
                    new mx.app.widget.Audit({
                        entityIds: entityIds,
                        entityClasses: params.auditFor,
                    }).show();
                }.createDelegate(this),
            });
        }
        if (!this.readOnly) {
            this.saveButton = this.addButton({
                text: this.labels.save,
                name: 'mx.app.widget.EditPanel.Save',
                handler: function() {
                    if (this.form.fireEvent('beforesubmit')) {
                        if (this.form.getForm().isValid()) {
                            if (this.form.fireEvent('beforeSubmitAfterValidation', this.form, this.form.record)) {
                                this.fireEvent('submit', this.form);
                            }
                        } else {
                            this.fireEvent('invalid', this.form);
                            var msg =
                                this.form.getWrongFieldMessage && typeof this.form.getWrongFieldMessage == 'function'
                                    ? this.form.getWrongFieldMessage()
                                    : undefined;

                            if (!msg) msg = {};

                            if (console && console.log) {
                                var formfields = [];
                                this.form.getForm().items.each(function(f) {
                                    if (!f.validate()) {
                                        formfields.push(f.name || f.id);
                                    }
                                });
                                console.log(['Invalid fields: ', formfields]);
                            }

                            Ext.Msg.show({
                                title: msg.title ? msg.title : this.labels.warning,
                                msg: msg.message ? msg.message : this.labels.someFieldsAreWrong,
                                icon: msg.type ? msg.type : Ext.Msg.WARNING,
                                buttons: Ext.Msg.OK,
                            });
                        }
                    }
                },
                scope: this,
            });
        }
        if (this.hasCloseButton) {
            this.closeButton = this.addButton({
                text: this.labels.close,
                name: 'mx.app.widget.EditPanel.Close',
                onClick: function() {
                    if (this.form.getForm().isDirty() && !this.form.readOnly) {
                        Ext.Msg.confirm(
                            this.labels.warning,
                            this.labels.doYouWantToLeave || this.doYouWantToLeaveLabel,
                            function(btn, text) {
                                if (btn == 'yes') {
                                    this.fireEvent('cancel', this.form);
                                }
                            }.createDelegate(this)
                        );
                    } else {
                        this.fireEvent('cancel', this.form);
                    }
                }.createDelegate(this),
            });
        }
    },
});
